import { useSelector } from 'react-redux';
 
import { Link } from 'react-router-dom';
import './Layout.css';

export default function Layout(props){
    let restaurant_data = useSelector( state => state.data);

    return (
        <>
        <div className='main__cover-background'>
            <Link to={ '/' + props.local }>
                <div className='main__restaurant-icon'>
                    {/* Dinamic */}
                    <img src={ restaurant_data ?  restaurant_data.logo : 'default.jpg'} alt='Logo del restaurante'/>
                </div>

            </Link>
        </div>

        <div className='main' style={ {marginTop: 80} }>
            { props.children }
        </div>

        
        <footer className='main__footer'>
                <p>© Encargamelo 2021. Todos los derechos reservados.</p>
            </footer>
        </>
    );
}